import React, { useEffect, useState } from 'react'
import Bredcrum from '../../common/Bredcrum'

import blog_image from "../../../assets/images/testimonial-bg.jpg"
import { Link, useNavigate, useParams } from 'react-router-dom'
import { blog_data } from './blog_data'
import { axiosInstance, config } from '../config'
import CommentSection from './Comments/CommentSection'
import moment from 'moment'

const BlogDetails = () => {

    const [blogData, setBlogData] = useState([])
    const [Loading,setLoading] = useState(false);

    const Navigate = useNavigate()

    const { post_slug } = useParams()

    useEffect(() => {
        setLoading(true)

        axiosInstance.get(`get-posts/${post_slug}`)
            .then(res => {
                setBlogData(res?.data?.posts) 
            })
            .catch((err) => {console.log(err)
                Navigate(`${config.appUrl}blogs`)
            })
            .finally(() => {
                setLoading(false)
            })


    }, [post_slug])

    useEffect(() => {
        // Select all tables inside div elements
        const tables = document.querySelectorAll('.blog_content table');
        if (tables) {
            // Loop through each table and wrap it inside a new div with the 'table-responsive' class
            tables.forEach(table => {
                // Create a new div element
                const wrapperDiv = document.createElement('div');
                wrapperDiv.classList.add('table-responsive');
 
                // Insert the new div before the table
                table.parentNode.insertBefore(wrapperDiv, table);
 
                // Move the table inside the new div
                wrapperDiv.appendChild(table);
            });
        }
    }, [blogData])

    return (
        <div>
            <Bredcrum
                heading={blogData?.name}
                path={[
                    { name: 'Post Details', path: 'blogs' },
                    { name: blogData.name, path: blogData.slug },
                ]}
            />
            <section className='py-5'>
                <div className='auto-container py-md-5 px-md-5'>
                    <div className='px-md-5'>
                        <div style={{
                            backgroundImage: `linear-gradient(#0a090c78, #0a090c78), url("${blogData?.imageUrl}")`,
                            backgroundSize: 'cover',
                            height: '550px'
                        }}
                            className='d-flex align-items-end p-md-5 p-4'
                        >
                            <div>
                                <h4 className='display-6 fw-semibold text-white'>
                                    {blogData?.name}
                                </h4>

                                <div className='mt-4 d-md-flex'>
                                    <div className='text-white'>
                                        <i className='bi bi-calendar-date me-2'></i>
                                        {moment(blogData?.created_at).format("DD MMMM, YYYY")}
                                    </div>
                                    <div className='text-white ms-md-4 mt-md-0 mt-2'>
                                        <i className='bi bi-person-circle me-2'></i>
                                        By Admin
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='blog_content mt-4'>
                            <p dangerouslySetInnerHTML={{__html : blogData?.description}}>
                            </p>
                            

                        </div>

                        <div className='my-5 pb-5'>
                            <CommentSection post_id={blogData?.id}/>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default BlogDetails